/**
 * Blog Load More Module
 * Handles AJAX loading of additional blog posts
 */

const BlogLoadMore = {
    init() {
        document.addEventListener('click', this.handleLoadMore.bind(this));
    },

    handleLoadMore(event) {
        if (!event.target.matches('.ms-blogposts__load-more')) return;
        
        event.preventDefault();
        const button = event.target;
        const container = button.closest('.ms-blogposts');
        
        if (!container) return;
        
        // Get configuration from data attributes
        const config = {
            count: parseInt(container.dataset.count) || 3,
            currentPage: parseInt(container.dataset.currentPage) || 1,
            maxPages: parseInt(container.dataset.maxPages) || 1,
            category: container.dataset.category || '',
            tag: container.dataset.tag || '',
            buttonText: container.dataset.buttonText || 'Read Blog',
            excerptWords: parseInt(container.dataset.excerptWords) || 28,
            nonce: container.dataset.nonce || '',
        };

        // Don't proceed if we're at the last page
        if (config.currentPage >= config.maxPages) {
            button.style.display = 'none';
            return;
        }

        // Show loading state
        const originalText = button.textContent;
        button.textContent = 'Loading...';
        button.disabled = true;

        // Prepare AJAX request
        const formData = new FormData();
        formData.append('action', 'ms_load_more_posts');
        formData.append('nonce', config.nonce);
        formData.append('page', config.currentPage + 1);
        formData.append('count', config.count);
        formData.append('category', config.category);
        formData.append('tag', config.tag);
        formData.append('button_text', config.buttonText);
        formData.append('excerpt_words', config.excerptWords);

        // Make AJAX request
        fetch(THI_DATA.site_url + '/wp-admin/admin-ajax.php', {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            if (data.success && data.data.html) {
                // Find the grid container and append new posts
                const grid = container.querySelector('.ms-blogposts__grid');
                if (grid) {
                    // Create temporary container to parse HTML
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = data.data.html;
                    
                    // Append each new post to the grid
                    const newPosts = tempDiv.querySelectorAll('.ms-blogpost');
                    newPosts.forEach(post => {
                        grid.appendChild(post);
                    });

                    // Update current page
                    container.dataset.currentPage = config.currentPage + 1;
                    
                    // Check if we've reached the last page
                    if ((config.currentPage + 1) >= config.maxPages) {
                        button.style.display = 'none';
                    }
                }
            } else {
                console.error('Error loading more posts:', data);
                // Hide button on error
                button.style.display = 'none';
            }
        })
        .catch(error => {
            console.error('AJAX Error:', error);
            button.style.display = 'none';
        })
        .finally(() => {
            // Restore button state
            button.textContent = originalText;
            button.disabled = false;
        });
    }
};

export default BlogLoadMore;